import './PatientListScreen.scss'
import React, {useCallback, useEffect, useState} from 'react';
import PatientListTableComponent from "./patient-list-table/PatientListTableComponent";
import {CommonService} from "../../shared/services";
import AddIcon from '@mui/icons-material/Add';
import {Link} from 'react-router-dom';
import ButtonComponent from "../../shared/components/core/button/ButtonComponent";
import {IAPIResponseType} from "../../shared/models/api.model";
import {Download, IosShare} from "@mui/icons-material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DrawerComponent from "../../shared/components/drawer/drawerComponent";
import PatientFiltersComponent from "./patient-filters/PatientFiltersComponent";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../store/actions/header.action";
import {IRootReducerState} from "../../store/reducers";
import _ from "lodash";
import SearchComponent from "../../shared/components/search/SearchComponent";
import commonService from "../../shared/services/common.service";
import ReorderIcon from "@mui/icons-material/Reorder";

interface PatientListScreenProps {

}

const FiltersInitialState: any = {
    search: '',
    genders: [],
    gendersObjs: [],
    cities: [],
    citiesObjs: [],
    createdByObjs: [],
    createdByIds: [],
    startDate: '',
    endDate: '',
    facilityObjs: [],
    facilityIds: [],
    locationObjs: [],
    locationIds: [],
}

const FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS = ['createdByObjs', 'citiesObjs', 'gendersObjs', 'facilityObjs', 'locationObjs'];
const showBulkUpload = true;//Todo: Remove this static variable
const PatientListScreen = (props: PatientListScreenProps) => {
        const [isCSVDownloading, setIsCSVDownloading] = useState(false);
        const [isExportingPatient, setIsExportingPatient] = useState(false);
        const [showFilterDrawer, setShowFiltersDrawer] = useState<boolean>(false);
        const dispatch = useDispatch();
        const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
        const {
            userList,
            citiesListLite,
            facilityListLite,
            locationListLite
        } = useSelector((state: IRootReducerState) => state.staticData);
        const [filterData, setFilterData] = useState<any>(_.cloneDeep(FiltersInitialState));
        const {currentUser} = useSelector((state: IRootReducerState) => state.account);

        useEffect(() => {
            dispatch(setCurrentNavParams("Patient", "Patient"));
            dispatch(setSideMenuView('default'));
        }, [dispatch]);


        const downloadCSV = useCallback(() => {
            const payload = {...filterData};
            setIsCSVDownloading(true);
            CommonService._patient.downloadPatientCSV(payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsCSVDownloading(false);
                    if (response && response?.data && response?.data?.attachmentUrl) {
                        CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'patientList', 'csv');
                    }
                })
                .catch((error: any) => {
                    setIsCSVDownloading(false);
                });
        }, [filterData]);

        const downloadPatientCSV = useCallback(() => {
            const payload = {...filterData};
            setIsExportingPatient(true);
            CommonService._patient.downloadAllPatientCSV(payload)
                .then((response: IAPIResponseType<any>) => {
                    setIsExportingPatient(false);
                    if (response && response?.data && response?.data?.attachmentUrl) {
                        CommonService.downloadFile(response?.data?.attachmentUrl, response?.data?.title || 'patientList', 'csv');
                    }
                })
                .catch((error: any) => {
                    setIsExportingPatient(false);
                });
        }, [filterData]);

        const handleSearch = useCallback((value: string) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: value
            }));
        }, []);

        useEffect(() => {
            if (queryParamData) {
                const data: any = {
                    search: queryParamData.search || '',
                    startDate: queryParamData.startDate || '',
                    endDate: queryParamData.endDate || '',
                };

                if (queryParamData?.createdByIds?.length) {
                    data['createdByIds'] = queryParamData.createdByIds.split(',') || [];
                }
                data['createdByObjs'] = userList.filter((item: any) => data['createdByIds']?.includes(item?.id?.toString()));

                if (queryParamData?.cities?.length) {
                    data['cities'] = queryParamData.cities.split(',') || [];
                }
                data['citiesObjs'] = citiesListLite?.filter((item: any) => data['cities']?.includes(item?.city));


                if (queryParamData?.genders?.length) {
                    data['genders'] = queryParamData?.genders.split(',') || [];
                }
                data['gendersObjs'] = CommonService._staticData.genderOptions?.filter((item: any) => data['genders']?.includes(item?.code));

                if (queryParamData?.facilityIds?.length) {
                    data['facilityIds'] = queryParamData.facilityIds.split(',') || [];
                }
                data['facilityObjs'] = facilityListLite.filter((item: any) => data['facilityIds']?.includes(item?.id?.toString()));

                if (queryParamData?.locationIds?.length) {
                    data['locationIds'] = queryParamData.locationIds.split(',') || [];
                }
                data['locationObjs'] = locationListLite.filter((item: any) => data['locationIds']?.includes(item?.id?.toString()));

                setFilterData((prevState: any) => ({
                    ...prevState, ...data
                }));
            }
        }, [queryParamData, citiesListLite, userList, facilityListLite, locationListLite]);

        const applyFilters = useCallback((filterData: any) => {
            setFilterData((prevState: any) => ({
                ...prevState,
                ...filterData
            }));
            setShowFiltersDrawer(false);
        }, []);

        useEffect(() => {
            CommonService.mapFilterDataToQueryParams(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS);
        }, [filterData]);

        const clearAllFilters = useCallback(() => {
            setFilterData(_.cloneDeep(FiltersInitialState));
        }, []);


        return (
            <div className="patient-list-screen screen">
                <div className={"screen-content-wrapper"}>
                    <div className="page-data-wrapper">
                        <div className="page-options">
                            <div className="page-search">
                                <SearchComponent
                                    label={"Search"}
                                    id="search_input"
                                    placeholder={"Search by patient name"}
                                    value={filterData.search}
                                    onChange={handleSearch}
                                />
                            </div>
                            <div className="page-extra-options">
                                {
                                    CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 &&
                                    <ButtonComponent
                                        type="button"
                                        id="clear_all_filters"
                                        color={"secondary"}
                                        variant={"text"}
                                        fullWidth={false}
                                        className={"clear-all-filters"}
                                        handleClick={clearAllFilters}
                                    >
                                        Clear All
                                    </ButtonComponent>
                                }

                                <ButtonComponent
                                    type="button"
                                    id="csv_btn"
                                    color={"primary"}
                                    variant={"outlined"}
                                    fullWidth={false}
                                    handleClick={() => setShowFiltersDrawer(true)}
                                    startIcon={<FilterAltIcon/>}>
                                    Filters {CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS) > 0 ? `( ${CommonService.getAppliedFiltersCount(filterData, FILTERS_STATE_MANAGEMENT_EXCLUDE_KEYS)} )` : ''}
                                </ButtonComponent>
                                {
                                    showBulkUpload && commonService.checkAccess('TestOrder', 'testOrderBulkList', currentUser?.userAccessModules) &&
                                    <Link to={CommonService._routeConfig.BulkPatientListRoute()}>
                                        <ButtonComponent
                                            type="button"
                                            id="bulk_patient_btn"
                                            color={"primary"}
                                            variant={"outlined"}
                                            fullWidth={false}
                                            startIcon={<ReorderIcon/>}
                                        >
                                            Bulk Patient Upload
                                        </ButtonComponent>
                                    </Link>
                                }
                                {
                                    commonService.checkAccess('Patient',
                                        'patientCsvDownload', currentUser?.userAccessModules) &&

                                    <ButtonComponent
                                        type="button"
                                        id="csv_btn"
                                        color={"secondary"}
                                        variant={"outlined"}
                                        fullWidth={false}
                                        isLoading={isCSVDownloading}
                                        handleClick={downloadCSV}
                                        disabled={isCSVDownloading}
                                        startIcon={<Download/>}
                                    >
                                        CSV
                                    </ButtonComponent>
                                }
                                {
                                    commonService.checkAccess('Patient',
                                        'patientCsvDownload', currentUser?.userAccessModules) &&

                                    <ButtonComponent
                                        type="button"
                                        id="csv_btn"
                                        color={"secondary"}
                                        variant={"outlined"}
                                        fullWidth={false}
                                        isLoading={isExportingPatient}
                                        handleClick={downloadPatientCSV}
                                        disabled={isExportingPatient}
                                        startIcon={<IosShare/>}
                                    >
                                        Export Data
                                    </ButtonComponent>
                                }
                                {
                                    commonService.checkAccess('Patient',
                                        'patientAdd', currentUser?.userAccessModules) &&
                                    <Link to={CommonService._routeConfig.PatientAddRoute()}>
                                        <ButtonComponent
                                            type="button"
                                            color={"primary"}
                                            variant={"contained"}
                                            id="add_patient_button"
                                            startIcon={<AddIcon/>}
                                        >
                                            New Patient
                                        </ButtonComponent>
                                    </Link>
                                }
                            </div>
                        </div>
                        <>
                            <PatientListTableComponent filterData={filterData}/>
                        </>
                    </div>
                </div>
                <DrawerComponent open={showFilterDrawer}
                                 className={"drawer-wrapper"}
                                 closeOnBackDropClick={true}
                                 closeOnEsc={true}
                                 onClose={() => setShowFiltersDrawer(false)}
                >
                    <PatientFiltersComponent filtersData={filterData} onFiltersApply={applyFilters}
                                             clearAllFilters={clearAllFilters}
                    />
                </DrawerComponent>
            </div>
        );
    }

;

export default PatientListScreen;
